<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'" id="adminHome"><a
        routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'" id="accountOwnerHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'" id="userHome"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/contacts/" id="contacts">Contacts</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Contacts</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Details</h2>
          <div class="row mt-3">
            <div class="col-lg-4 required">
              <div class="form-group ">
                <label class="control-label" for="customerType">Customer Type</label>
                <select id="customerType" class="form-control" [(ngModel)]="customerType"
                        (blur)="selectCustomerType()" [ngClass]="{'is-invalid':statusText10}"
                        [ngModelOptions]="{standalone: true}" required>
                  <option value="Sender">Sender</option>
                  <option value="Receiver">Receiver</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group ">
                <label class="control-label" for="companyName">Company Name</label>
                <input type="text" id="companyName" [(ngModel)]="companyName" class="form-control"
                       [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}" required>
              </div>
            </div>
            <div class="col-lg-4 required">
              <div class="form-group ">
                <label class="control-label" for="name">Name</label>
                <input type="text" id="name" [(ngModel)]="contactName" class="form-control" (blur)="createContactName()"
                       [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}"
                       onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                       autocomplete="off" required>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 required">
              <div class="form-group ">
                <label class="control-label" for="email">Email</label>
                <input type="text" id="email" [(ngModel)]="email" class="form-control" (blur)="validateEmail()"
                       [ngClass]="{'is-invalid':statusText3}" [ngModelOptions]="{standalone: true}" required>
              </div>
            </div>
            <div class="col-lg-4 required">
              <div class="form-group ">
                <label class="control-label" for="phone">Phone Number</label>
                <input type="text" id="phone" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                       (blur)="createMobile()" [ngClass]="{'is-invalid':statusText4}" [(ngModel)]="mobile"
                       maxlength="10" class="form-control" [ngModelOptions]="{standalone: true}" required>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 mb-1 text-danger fw-500"
           *ngIf="statusText4 || statusText3 || statusText1 || statusText2 || statusText10 || statusText9 || statusText5 || statusText6 || statusText7 || statusText8 ">
        Please Enter Mandatory Fields
      </div>

      <div class="col">
        <ul class="list-inline tab-list">
          <li class="list-inline-item ml-2"><a class="list-inline-item" (click)=" tabChange('address');"
                                               [ngClass]="{'active': tabClicked === 'address'}">Address
            <div class="dot bg-danger ml-2"
                 *ngIf="statusText9 || statusText5 || statusText6 || statusText7 || statusText8 "></div>
          </a></li>
          <li class="list-inline-item ml-3"><a class="nav-link warehouses" (click)=" tabChange('instructions');"
                                               [ngClass]="{'active': tabClicked === 'instructions'}">Instructions</a>
          </li>
        </ul>
        <div class="inner-box">
          <div *ngIf="tabClicked == 'address'">
            <h2 class="text-black mb-3">Address</h2>
            <div class="row">
              <div class="col-md-4 required">
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 required">
                <div class="form-group ">
                  <label class="control-label" for="address1">Address 1</label>
                  <input type="text" id="address1" [(ngModel)]="address.address1" class="form-control"
                         (blur)="createAddress()" [ngClass]="{'is-invalid':statusText5}"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="control-label" for="address2">Address 2</label>
                  <input type="text" id="address2" [(ngModel)]="address.address2" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4 required">
                <div class="form-group ">
                  <label class="control-label">City</label>
                  <ng-select id="city" [(ngModel)]="address.city"
                             [ngModelOptions]="{standalone: true}" [items]="citiesList" placeholder="City"
                             (blur)="createCity()" [ngClass]="{'is-invalid':statusText6}" required>
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 required">
                <div class="form-group ">
                  <label class="control-label">State</label>
                  <ng-select id="State" [(ngModel)]="address.state" [ngModelOptions]="{standalone: true}"
                             [ngClass]="{'service-error':statusText7}"
                             (blur)="createState()"
                             [ngClass]="{'is-invalid':statusText7}"
                             [items]="statesList"
                             placeholder="State">
                  </ng-select>
                </div>
              </div>

              <div class="col-md-4 required">
                <div class="form-group ">
                  <label class="control-label" for="accountZipAlt">Zip</label>
                  <input type="text" id="accountZipAlt" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                         maxlength="6" [(ngModel)]="address.zip" class="form-control" (change)="changeStateAndCity()"
                         (blur)="createZip()" [ngClass]="{'is-invalid':statusText8}" placeholder="Enter PinCode"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
            </div>
          </div>


          <div class="" *ngIf="tabClicked == 'instructions'">
            <h2 class="text-black">Instructions</h2>
            <div class="row mt-3">
              <div class="col-lg-5">
                <div class="required">
                  <textarea id="requestNotes" [(ngModel)]="deliveryInstructions" class="form-control" rows="6"
                            maxlength="250" [ngModelOptions]="{standalone: true}" required></textarea>
                </div>
              </div>
            </div>
          </div>


        </div>

      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/contacts" class="btn btn-cancel" id="cancel">Cancel</button>
      <button type="submit" *ngIf="tabClicked == 'address'" (click)="nextPage()" class="btn btn-orange ml-2" id="Next">
        Next
      </button>
      <button type="submit" *ngIf="tabClicked == 'instructions'" (click)="submitContacts()" class="btn btn-orange ml-2"
              id="save">Save
      </button>
    </div>
  </div>
</div>
